import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

const ServiceRequesitionTable = Loadable(
  lazy(() =>
    import("./ServiceRequesitionTable").then(({ ServiceRequesitionTable }) => ({
      default: ServiceRequesitionTable,
    })),
  ),
);

const SingleServiceRequesitionForm = Loadable(
  lazy(() =>
    import("./SingleServiceRequesitionForm").then(
      ({ SingleServiceRequesitionForm }) => ({
        default: SingleServiceRequesitionForm,
      }),
    ),
  ),
);

export const serviceRequesitionRoutes = [
  {
    path: app_navbar_routes.app.service.service_requesition,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_REQUESITION]}>
        <ServiceRequesitionTable module="GENERAL" />
      </AuthorizedRoute>
    ),
  },
  {
    path: app_navbar_routes.app.approvals.service_requesition,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.APPROVAL_SERVICE_REQUESITION]}>
        <ServiceRequesitionTable module="APPROVAL" />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.service.service_requesition}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_REQUESITION]}>
        <SingleServiceRequesitionForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.service.service_requesition}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.SERVICE_REQUESITION]}>
        <SingleServiceRequesitionForm />
      </AuthorizedRoute>
    ),
  },
];
